// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import {ID3EPolicy} from '../../../../types/d3ePolicy';
import { ConfigurationService } from 'src/services/configuration-service';

@Component({
    selector: 'app-fde-info',
    templateUrl: './fde-info.component.html',
    standalone: false
})
export class FdeInfoComponent {
  @Input() d3ePolicy: ID3EPolicy;
  @Output() onChanged:  EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public configurationService: ConfigurationService
  ) {
  }

  onFdeInfoChanged() {
    this.onChanged.emit();
  }
}
